import React from 'react';
import { Clock, ShieldCheck, PiggyBank, Leaf, Home, Zap } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from './ui/Card';
export function BenefitsSection() {
  const benefits = [{
    icon: Clock,
    title: 'Unmatched Convenience',
    description: 'Wake up to a clear driveway every morning. No more early wake-ups to shovel before work or coming home to a wall of snow.'
  }, {
    icon: ShieldCheck,
    title: 'Enhanced Safety',
    description: 'Eliminate the risk of slips and falls on icy surfaces. Keep your family, visitors, and delivery personnel safe all winter.'
  }, {
    icon: PiggyBank,
    title: 'Long-Term Savings',
    description: 'Stop paying for expensive snow removal contracts. Our systems are designed to be cost-effective and energy-efficient.'
  }, {
    icon: Leaf,
    title: 'Eco-Friendly',
    description: 'Reduce your environmental impact by eliminating the need for harsh de-icing chemicals and salts that damage local waterways.'
  }, {
    icon: Home,
    title: 'Increased Property Value',
    description: 'A heated driveway is a premium feature that sets your home apart, increasing its resale value and curb appeal.'
  }, {
    icon: Zap,
    title: 'Reliable Performance',
    description: 'Engineered specifically for harsh Canadian winters, our systems perform reliably even in extreme cold conditions.'
  }];
  return <section id="benefits" className="py-16 bg-gradient-to-b from-slate-50 to-white md:py-24 relative overflow-hidden" data-id="element-16">
      {/* Decorative background blobs */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none" data-id="element-17">
        <div className="absolute top-[10%] left-[-5%] w-96 h-96 bg-blue-100/50 rounded-full blur-3xl" data-id="element-18"></div>
        <div className="absolute bottom-[10%] right-[-5%] w-96 h-96 bg-teal-100/50 rounded-full blur-3xl" data-id="element-19"></div>
      </div>

      <div className="container mx-auto px-4 md:px-6 relative z-10" data-id="element-20">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-21">
          <h2 className="text-3xl font-bold tracking-tight text-slate-900 sm:text-4xl" data-id="element-22">
            Why Homeowners Choose Heated Driveways
          </h2>
          <p className="mt-4 text-lg text-slate-600" data-id="element-23">
            Beyond just melting snow, our systems provide peace of mind, safety,
            and value for your home.
          </p>
        </div>

        <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3" data-id="element-24">
          {benefits.map((benefit, index) => <Card key={index} className="border shadow-sm hover:shadow-xl transition-all duration-300 hover:-translate-y-2 group bg-white/80 backdrop-blur-sm" data-id="element-25">
              <CardHeader data-id="element-26">
                <div className="w-12 h-12 rounded-lg bg-primary/10 flex items-center justify-center mb-2 group-hover:bg-primary group-hover:text-white transition-colors duration-300" data-id="element-27">
                  <benefit.icon className="h-6 w-6 text-primary group-hover:text-white transition-colors duration-300" data-id="element-28" />
                </div>
                <CardTitle className="text-xl group-hover:text-primary transition-colors" data-id="element-29">
                  {benefit.title}
                </CardTitle>
              </CardHeader>
              <CardContent data-id="element-30">
                <p className="text-slate-600 leading-relaxed" data-id="element-31">
                  {benefit.description}
                </p>
              </CardContent>
            </Card>)}
        </div>
      </div>
    </section>;
}